import React, { useState, useEffect, useMemo } from 'react';

export const TemplateContext = React.createContext();

export const TemplateStateProvider = ({ children, initialState }) => {
  const [variables, setVariables] = useState(initialState);

  // Memoize serialized state for stable dependency
  const serializedInitialState = useMemo(() => JSON.stringify(initialState), [initialState]);

  // Sync state when initialState changes (e.g., after data refetch)
  useEffect(() => {
    setVariables(initialState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serializedInitialState]);

  return <TemplateContext.Provider value={{ variables, setVariables }}>{children}</TemplateContext.Provider>;
};

export const withTemplateCtx = Component => props => (
  <TemplateContext.Consumer>{ctx => <Component {...props} {...ctx} />}</TemplateContext.Consumer>
);
